export const STUDENT_DISCOUNT_PATHS = [
  '/studentenkorting/verificatie',
  '/student-discount/verification',
  '/reduction-etudiant/verification',
  '/studentenrabatt/verifizierung'
];
